import { TableRow, TableCell, Button, IconButton, Box, Typography } from '@mui/material'
import { styled } from '@mui/system'

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.grey[50]
  },
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    '& .cancel-icon': {
      opacity: 1,
      visibility: 'visible'
    }
  },
  '& td': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`
  },
  '&.header-row': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  '& .cancel-icon': {
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.2s ease, visibility 0.2s ease'
  }
}))

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary[99],
  fontWeight: 500,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  padding: '12px 16px',
  '&.header-cell': {
    backgroundColor: theme.palette.primary[99]
  }
}))

export const CancelButton = styled(Button)(({ theme }) => ({
  borderRadius: 4,
  textTransform: 'none',
  fontSize: '0.75rem',
  padding: '2px 8px',
  minWidth: 'auto',
  borderColor: theme.palette.grey[400],
  color: theme.palette.text.primary,
  '&:hover': {
    borderColor: theme.palette.grey[600],
    backgroundColor: theme.palette.grey[100]
  }
}))

export const CancelIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.error.main,
  padding: 4,
  '&:hover': {
    backgroundColor: theme.palette.error.light + '20'
  }
}))

// Modal Styles
export const DetailContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3)
}))

export const DetailRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-child': {
    borderBottom: 'none'
  }
}))

export const DetailLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: theme.palette.text.primary
}))

export const DetailValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.text.primary
}))

export const ConfirmButton = styled(Button)(() => ({
  background: 'linear-gradient(90deg, #58c1d1 0%, #2092a4 100%)',
  borderRadius: 12,
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  padding: '12px 24px',
  color: '#fff',
  boxShadow: 'none',
  '&:hover': {
    background: 'linear-gradient(90deg, #053c50 0%, #1e8a9b 100%)',
    boxShadow: '0px 4px 12px rgba(85, 107, 247, 0.3)'
  }
}))

export const NoteText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  lineHeight: 1.5
}))

export const AcademyLink = styled('a')(() => ({
  color: '#58c1d1',
  textDecoration: 'none',
  fontWeight: 600,
  '&:hover': {
    textDecoration: 'underline'
  }
}))
